import 'css-chunksrc/client/scenes/moveElement/projectsSelection/loader/styles.scss';export default {
  "loader": "_loader_1li1x_1",
  "item": "_item_1li1x_5",
  "checkbox": "_checkbox_1li1x_15",
  "name": "_name_1li1x_23"
};